import { useContext, useMemo } from 'react'
import GeoContext from 'contexts/geoContext'
import { getPlaceByRegionCode } from 'constants/places'
import { ANYWHERE_PLACE_ID } from 'constants/search'
import useRecentSearches from 'hooks/Search/useRecentSearches'

function useExperienceSearchFallback(): App.SearchDestination {
  const recentSearches = useRecentSearches()
  const geo = useContext(GeoContext)

  return useMemo(() => {
    const sevenDaysAgo = new Date()
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7)

    const lastDestinationSearch = recentSearches.find(
      s => s.searchItem?.searchType === 'destination' &&
        s.searchItem.value !== ANYWHERE_PLACE_ID &&
        new Date(s.dateAdded) >= sevenDaysAgo,
    )
    if (lastDestinationSearch?.searchItem) {
      return {
        searchType: 'destination',
        value: lastDestinationSearch.searchItem.value,
        format: { mainText: lastDestinationSearch.searchItem.format.mainText },
      }
    }

    const regionPlace = getPlaceByRegionCode(geo.currentRegionCode)
    return {
      searchType: 'destination',
      value: regionPlace.id,
      format: { mainText: regionPlace.name },
    }
  }, [recentSearches, geo.currentRegionCode])
}

export default useExperienceSearchFallback
